var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperRollSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "paper-roll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32h20v-17.088q1.92 1.088 4 1.088 3.328 0 5.664-2.336t2.336-5.664-2.336-5.632-5.664-2.368h-16q-3.296 0-5.664 2.368t-2.336 5.632v24zM4 28v-20q0-1.632 1.184-2.816t2.816-1.184h9.12q-1.12 1.92-1.12 4v20h-12zM6.016 26.016h8v-2.016h-8v2.016zM6.016 20h8v-1.984h-8v1.984zM6.016 14.016h8v-2.016h-8v2.016zM6.016 8h8v-1.984h-8v1.984zM20 8q0-1.632 1.184-2.816t2.816-1.184 2.816 1.184 1.184 2.816-1.184 2.848-2.816 1.152-2.816-1.152-1.184-2.848z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperRollSvgrepoCom);
export default __webpack_public_path__ + "static/media/paper-roll-svgrepo-com.a8fa9aefbd757413cb0e50eba544181f.svg";
export { ForwardRef as ReactComponent };